"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 行业估值分析
 */
require("emdataview");
var base_1 = __importDefault(require("./base"));
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var webconfig = require('../../config/web');
var public_1 = require("./public");
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
;
(function ($) {
    var markLine = {
        data: [
            {
                name: "最大值",
                type: "max",
                lineStyle: {
                    color: "#8148BD"
                }
            },
            {
                name: "最小值",
                type: "min",
                lineStyle: {
                    color: "#FFC048"
                }
            },
            {
                name: "平均值",
                type: "average",
                lineStyle: {
                    color: "#487D38"
                }
            },
        ],
        label: {
            position: "middle"
        }
    };
    var hyObj = {
        init: function () {
            var that = this;
            this.type = "PE_TTM";
            this._stockData = null;
            this._geguData = [];
            this._rankIndex = 1;
            this.pxIndex = 2;
            this.isMuch = (this.type === "TOTAL_MARKET_CAP" || this.type === "NOTLIMITED_MARKETCAP_A" || this.type === "TOTAL_SHARES");
            this.typeName = "PE(TTM)";
            this.line_chart = echarts.init(document.getElementById('emchart-k'));
            this.getTopStockData();
            this.getChartData();
            this.getHyData();
            this.loadHygzData();
            $('#hypm_table').on('click', '.sortable', function () {
                that.type = $(this).data("sortname");
                that.typeName = $(this).text();
                var index = $(this).parent("th").index();
                that.isMuch = (that.type === "TOTAL_MARKET_CAP" || that.type === "NOTLIMITED_MARKETCAP_A" || that.type === "TOTAL_SHARES");
                if (index != that.pxIndex) {
                    that.pxIndex = index;
                    that.refresh();
                }
            });
        },
        refresh: function () {
            var that = this;
            this._geguData = [];
            that.getHyTabData(function () {
                that.loadHtml();
                that.getChartData();
            });
        },
        getTopStockData: function () {
            var that = this;
            $.ajax({
                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                type: 'get',
                dataType: 'jsonp',
                data: {
                    reportName: "RPT_VALUEINDUSTRY_DET",
                    columns: "ALL",
                    quoteColumns: "",
                    pageNumber: 1,
                    pageSize: 1,
                    sortColumns: "TRADE_DATE",
                    sortTypes: -1,
                    source: "WEB",
                    client: "WEB",
                    filter: "(BOARD_CODE=\"" + hyInfo.hyCode + "\")"
                }
            }).then(function (json) {
                var res = json && json.result && json.result.data;
                if (res.length > 0) {
                    var data = res[0];
                    var html = "";
                    html += "<li data-zd='TOTAL_MARKET_CAP'>总市值 " + utils_1["default"].FixAmt(data.TOTAL_MARKET_CAP) + "</li>" +
                        "<li data-zd='PE_TTM'>PE(TTM) " + utils_1["default"].toFixed2(data.PE_TTM) + "</li>" +
                        "<li data-zd='PE_LAR'>PE静 " + utils_1["default"].toFixed2(data.PE_LAR) + "</li>" +
                        "<li data-zd='PB_MRQ'>市净率 " + utils_1["default"].toFixed2(data.PB_MRQ) + "</li>" +
                        "<li data-zd='TOTAL_SHARES'>总股本 " + utils_1["default"].FixAmt(data.TOTAL_SHARES) + "</li>" +
                        "<li data-zd='PCF_OCF_TTM'>市现率 " + utils_1["default"].toFixed2(data.PCF_OCF_TTM) + "</li>" +
                        "<li data-zd='PS_TTM'>市销率 " + utils_1["default"].toFixed2(data.PS_TTM) + "</li>" +
                        "<li data-zd='PEG_CAR'>PEG " + utils_1["default"].toFixed2(data.PEG_CAR, 4) + "</li>";
                    $("#stockInfo").html(html);
                }
            }).fail(function (err) {
                console.log(err);
            });
        },
        getChartData: function () {
            var that = this;
            $.ajax({
                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                type: 'get',
                dataType: 'jsonp',
                data: {
                    reportName: "RPT_VALUEINDUSTRY_DET",
                    columns: "ALL",
                    quoteColumns: "",
                    pageNumber: 1,
                    pageSize: 5000,
                    sortColumns: "TRADE_DATE",
                    sortTypes: -1,
                    source: "WEB",
                    client: "WEB",
                    filter: "(BOARD_CODE=\"" + hyInfo.hyCode + "\")"
                }
            }).then(function (json) {
                var res = json && json.result && json.result.data;
                that.chartData = res;
                that.drawChart();
            }).fail(function (err) {
                console.log(err);
            });
        },
        drawChart: function () {
            var that = this;
            if (!that.chartData) {
                return;
            }
            that.line_chart.showLoading({
                text: '图表加载中...' //loading
            });
            var data = that.chartData;
            that.XData = [];
            that.YData = [];
            for (var i = 0, len = data.length; i < len; i++) {
                var item = data[i];
                that.XData.unshift(public_1.dateFormate2(item.TRADE_DATE, 'yyyy/MM/dd'));
                if (that.isMuch) {
                    that.YData.unshift(utils_1["default"].toFixed2(parseFloat(item[that.type]) / 1e8));
                }
                else {
                    that.YData.unshift(utils_1["default"].toFixed2(item[that.type]));
                }
            }
            var name = that.typeName.replace(/\(([元|股])\)/, "(亿$1)");
            var option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    left: 20,
                    selectedMode: false
                },
                grid: {
                    x: '6%',
                    y: '12%',
                    width: '88%',
                    height: '70%'
                },
                dataZoom: [
                    {
                        type: "slider",
                        show: true,
                        showDetail: false,
                        start: 70,
                        end: 100
                    },
                    { type: "inside" }
                ],
                xAxis: {
                    type: 'category',
                    data: that.XData,
                    axisLine: {
                        lineStyle: {
                            color: '#4488BB',
                            width: 2
                        }
                    },
                    axisTick: { show: false },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#000'
                        }
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        scale: true,
                        nameTextStyle: {
                            color: '#000'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#4488BB',
                                width: 2
                            }
                        },
                        axisTick: { show: false },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dotted',
                                color: "#E6E6E6"
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#000'
                            }
                        }
                    },
                    {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            lineStyle: {
                                color: '#4488BB',
                                width: 2
                            }
                        },
                        axisTick: { show: false },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#000'
                            }
                        }
                    }
                ],
                series: [
                    {
                        type: 'line',
                        name: hyInfo.hyName + name,
                        data: that.YData,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: '#2fade6',
                            normal: {
                                color: '#2fade6',
                                borderColor: "#2fade6"
                            }
                        },
                        markLine: markLine
                    }
                ]
            };
            that.line_chart.setOption(option);
            that.line_chart.hideLoading();
        },
        getHyTabData: function (callback) {
            var that = this;
            var sortType = that.isMuch ? "-1" : "1";
            var sortName = that.type;
            $.ajax({
                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                type: 'get',
                dataType: 'jsonp',
                data: {
                    reportName: "RPT_VALUEANALYSIS_DET",
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    sortColumns: sortName,
                    sortTypes: sortType,
                    filter: "(TRADE_DATE='" + currentDate + "')(BOARD_CODE=\"" + hyInfo.hyCode + "\")"
                }
            }).then(function (json) {
                var count = 0;
                var data = json && json.result && json.result.data;
                for (var i = 0; i < data.length; i++) {
                    var item = data[i];
                    if (count < 10 && item[that.type] > 0) {
                        item.rank = count * 1 + 1;
                        that._geguData.push(item);
                        count++;
                    }
                }
                callback && callback();
            }).fail(function (err) {
                console.log(err);
            });
        },
        getHyData: function () {
            var that = this;
            $.ajax({
                url: webconfig.getWebPath('datacenter') + "api/data/v1/get",
                type: 'get',
                dataType: 'jsonp',
                data: {
                    reportName: 'RPT_VALUEINDUSTRY_STA',
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    // sortColumns: sortName,
                    // sortTypes:sortType,
                    p: 1,
                    filter: "(BOARD_CODE=\"" + hyInfo.hyCode + "\")"
                }
            }).then(function (json) {
                that._hyData = json && json.result && json.result.data;
                that.getHyTabData(function () {
                    that.loadHtml();
                });
            }).fail(function (err) {
                console.log(err);
            });
        },
        getStockHtml: function (data) {
            var html = "";
            if (this._stockData) {
                var item = this._stockData;
                html += "<tr><td>" + this._rankIndex + "</td><td><a href='/gzfx/detail/" + item.SECURITY_CODE + ".html' target='_blank'>" + fieldtools_1["default"].fmtsname(item.SECURITY_NAME_ABBR) + "</a></td>" + this.getHtml(item, true) + "</tr>";
            }
            $('#stockInfo li[data-zd="' + this.type + '"]').addClass("active").siblings().removeClass("active");
            return html;
        },
        getGeguHtml: function (data) {
            var html = "";
            if (this._geguData) {
                var data_1 = this._geguData;
                for (var i = 0; i < data_1.length; i++) {
                    html += "<tr><td>" + data_1[i].rank + "</td><td><a href='/gzfx/detail/" + data_1[i].SECURITY_CODE + ".html' target='_blank'>" + fieldtools_1["default"].fmtsname(data_1[i].SECURITY_NAME_ABBR) + "</a></td>" + this.getHtml(data_1[i]) + "</tr>";
                }
            }
            return html;
        },
        getHtml: function (data, isBold) {
            var html = [];
            var str = isBold ? "style='font-weight: bold;'" : "";
            var zsz = "", ltsz = "", zgb = "";
            html.push("<td><span " + str + ">" + utils_1["default"].toFixed2(data.PE_TTM) + "</span></td>"); //PE动
            html.push("<td><span " + str + ">" + utils_1["default"].toFixed2(data.PE_LAR) + "</span></td>"); //PE静
            html.push("<td><span " + str + ">" + utils_1["default"].toFixed2(data.PB_MRQ) + "</span></td>"); //市净率
            html.push("<td><span " + str + ">" + utils_1["default"].toFixed2(data.PEG_CAR, 4) + "</span></td>"); //PEG
            html.push("<td><span " + str + ">" + utils_1["default"].toFixed2(data.PCF_OCF_TTM) + "</span></td>"); //市现率
            html.push("<td><span " + str + ">" + (data.INDUSTRY_TYPE == "行业平均" ? utils_1["default"].FixAmt(data.MARKET_CAP_VAG) : utils_1["default"].FixAmt(data.TOTAL_MARKET_CAP)) + "</span></td>"); //总市值 只有行业平均所用的字段不一样
            html.push("<td><span " + str + ">" + (data.INDUSTRY_TYPE == "行业平均" ? utils_1["default"].FixAmt(data.NOMARKETCAP_A_VAG) : utils_1["default"].FixAmt(data.NOTLIMITED_MARKETCAP_A)) + "</span></td>"); //流通市值 
            html.push("<td><span " + str + ">" + (data.INDUSTRY_TYPE == "行业平均" ? utils_1["default"].FixAmt(data.TOTAL_SHARES_VAG) : utils_1["default"].FixAmt(data.TOTAL_SHARES)) + "</span></td>"); //总股本 
            if (this.pxIndex >= 2) {
                var index = this.pxIndex - 2;
                html[index] = html[index].replace(/<td>/g, "<td class='asc_col'>");
            }
            return html.join("");
        },
        getHyHtml: function (data) {
            var html = "";
            if (this._hyData) {
                var data_2 = this._hyData;
                for (var i = 0; i < data_2.length; i++) {
                    html += "<tr><td colspan='2'>" + data_2[i].INDUSTRY_TYPE + "</td>" + this.getHtml(data_2[i], true) + "<tr/>";
                }
            }
            return html;
        },
        loadHtml: function () {
            var that = this;
            var html = this.getStockHtml() + this.getHyHtml() + this.getGeguHtml();
            if (html) {
                $("#hypm_table tbody").html(html);
            }
        },
        loadHygzData: function () {
            var opt = {
                dataurl: {
                    hostname: "datacenter",
                    url: "api/data/v1/get",
                    params: {
                        reportName: "RPT_VALUEINDUSTRY_DET",
                        columns: "ALL",
                        quoteColumns: "",
                        pageSize: 50,
                        source: "WEB",
                        client: "WEB",
                        filter: "(BOARD_CODE=\"" + hyInfo.hyCode + "\")"
                    }
                },
                urlkeyvalues: base_1["default"].urlkeyvalues,
                sortname: "TRADE_DATE",
                totalpagesfield: 'result.pages',
                datafield: 'result.data',
                pagination: true,
                columns: base_1["default"].columns.hygz,
                formatter: { num: 2 }
            };
            $("#hygz_table").emdataview(opt);
        }
    };
    hyObj.init();
})(jQuery);
